import { Box, Button, Typography } from "@mui/joy";
import Add from "@mui/icons-material/Add";
import React, { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import {
  GenericTableColumTypes,
  GenericTableFilterTypes,
} from "../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { removeClient } from "../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { RouteComponentProps } from "../../models/RouteComponent";
import { removeEquipmentType } from "../../service/equipmentTypesService";
import { removeChemicalType, chemicalTypeAdd } from "../../service/chemicalTypesService";
import ControlMeasureTypeAdd from "./control-measure-types-Add";
import { removeControlMeasureType } from "../../service/controlMeasureService";

export default function ControlMeasureTypeTable(props: RouteComponentProps) {
  const [selectedType, setTypes] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const baseFilter = {
    name: { value: "", matchMode: FilterMatchMode.CONTAINS },
  };

  const deleteButton = (row: any) => {
    console.log("deleteButton row == ", selectedType);
    removeClient(selectedType.id);
  };

  const addButton = (row: any) => {
    console.log("addButton row == ", row);
    setTypes(null);
    setVisible(true);
  };

  const itemSelected = (row: any) => {
    console.log("itemSelected row == ", row);
    setTypes(row.value);
    editConfirm(row);
  };

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row);
    setTypes(row.value);
  };

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const industry = await removeControlMeasureType(selectedType.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({
      severity: "success",
      summary: "Control Measure Type Deleted Successfully",
      life: 3000,
    });
  };

  const editConfirm = (row: any) => {
    setVisible(true);
  };

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => acceptFunc(),
    });
  };

  const contextItems = () => {
    let objArray = [
      { label: "Edit", icon: "pi pi-fw pi-pencil", command: editConfirm },
    ];
    // objArray.push({
    //   label: "Duplicate",
    //   icon: "pi pi-fw pi-copy",
    //   command: duplicate,
    // });
    objArray.push({
      label: "Delete",
      icon: "pi pi-fw pi-trash",
      command: deleteConfirm,
    });
    return objArray;
  };

  const duplicate = (row: any) => {
    props.setGlobalLoader(true);
    chemicalTypeAdd({
      name: `${selectedType.name} Duplicate`,
      chemical_safe_checklist: selectedType.chemical_safe_checklist,
      chemical_risk_checklist: selectedType.chemical_risk_checklist,
    })
      .then((r: any) => {
        toast.current.show({
          severity: "success",
          summary: "Hazard Created Successfully",
          life: 3000,
        });
        props.setGlobalLoader(false);
        setReload(!reload);
      })
      .catch((err: any) => {
        toast.current.show({
          severity: "error",
          summary: "Failed to Create Hazard",
          life: 3000,
        });
        props.setGlobalLoader(false);
      });
  };

  const columns: GenericTableColumns[] = [
    {
      field: "name",
      header: "Name",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: 'description',
      header: 'Description',
      type: GenericTableColumTypes.HTML,
      visible: true,
      sort: true,
      filter: false
    },
  ];

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          mb: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "start", sm: "center" },
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Typography level="h2" component="h1">
          Control Measure Types
        </Typography>

        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>

      <GenericTableView
        reload={reload}
        baseFilters={baseFilter}
        url="control-measure-type"
        columns={columns}
        contextItems={contextItems}
        addButton={addButton}
        itemSelect={itemSelected}
        contextItemSelected={contextItemSelected}
      />

      <Dialog
        ref={dialog}
        header={selectedType?.id ? "Update Control Measure Type" : "Add Control Measure Type"}
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
      >
        <ControlMeasureTypeAdd
          setGlobalLoading={props.setGlobalLoader}
          setReload={setReload}
          reload={reload}
          id={selectedType?.id}
          details={selectedType}
          setVisible={setVisible}
          toast={toast}
        />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />
    </React.Fragment>
  );
}
